import { render, staticRenderFns } from "./cPage.vue?vue&type=template&id=2fb4cc7c&scoped=true&"
import script from "./cPage.vue?vue&type=script&lang=js&"
export * from "./cPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb4cc7c",
  null
  
)

export default component.exports